<template>
  <div class="pwc-navigation">
    <div class="pwc-nav-content">
      <v-layout style="height:100%">
        <v-flex xs5>
          <v-img :src="logo" class="pwc-youplus-logo" />
        </v-flex>
        <v-flex class="pwc-youplus-action">
          <v-btn v-if="eventList.length > 0" :class="event" color="#d04a02" outline @click.native="handleGoevent">近期活动</v-btn>
          <v-btn :class="document" color="#d04a02" outline @click.native="handleGoApply">项目申请</v-btn>
          <v-btn :class="home" color="#d04a02" outline @click.native="handleGoHome">个人中心</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'
import RouterName from '@/constants/route'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      event: '',
      home: '',
      document: '',
      logo
    }
  },
  computed: {
    ...mapState(['eventList', 'campaignId'])
  },
  watch: {
    $route() {
      this.updateActive()
    }
  },
  created() {
    this.updateActive()
  },
  methods: {
    handleGoevent() {
      const query = { active: 'event' }
      if (this.campaignId) {
        query.campaignId = this.campaignId
      }
      this.$router.replace({
        name: RouterName.home,
        query: query
      })
    },
    handleGoApply() {
      const query = { active: 'document' }
      if (this.campaignId) {
        query.campaignId = this.campaignId
      }
      this.$router.replace({
        name: RouterName.home,
        query: query
      })
    },
    handleGoHome() {
      const query = { active: 'self' }
      if (this.campaignId) {
        query.campaignId = this.campaignId
      }
      this.$router.replace({
        name: RouterName.home,
        query: query
      })
    },
    updateActive() {
      const path = this.$route.path
      const query = this.$route.query

      if (!path.includes('home') || !query) {
        return
      }
      if (query['active'] === 'event') {
        this.event = 'active'
        this.home = ''
        this.document = ''
      }
      if (query['active'] === 'self' || !query['active']) {
        this.home = 'active'
        this.event = ''
        this.document = ''
      }
      if (query['active'] === 'document') {
        this.document = 'active'
        this.event = ''
        this.home = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-navigation {
    width: 100vw;
    height: 100px;
    // margin-left: -12px;
    background-color: #fff;
    box-shadow: 0 0.0625rem 0.125rem 0.0625rem rgba(0,0,0,.08);
    .pwc-nav-content {
      margin:auto;
      max-width: 960px;
      height: 100%;
      .pwc-youplus-logo {
        width:180px;
        margin-top: 28px;
        margin-left: -92px;
      }
      .pwc-youplus-action {
        height: 100%;
        display: flex;
        justify-content: flex-end;
        > button {
          height: 100px;
          border: none;
          &.active::before {
            background-color: currentColor;
          }
        }
      }
    }
}
@media all and (max-width: 960px)  {
  .pwc-navigation {
    height: 100px;
    margin-bottom: -20px;
    .pwc-nav-content {
      .pwc-youplus-logo {
        width: 160px;
        margin-top: 28px;
        margin-left: 10px;
      }
    }
  }
}
</style>

<style lang="scss">
.pwc-navigation {
    .pwc-youplus-action {
        .v-btn {
            margin: 0 0;
        }
    }
}
</style>
